export default __webpack_public_path__ + "static/pranoysarkar-8e4c7734a04b1beb17853ab55005d0fc.png";